// extracted by css-extract-rspack-plugin
export default {"bar":"bar-Kz4can"};